export default __webpack_public_path__ + "static/media/background.1b853ae5.png";